import React from 'react';
import './login.css'
import pic1 from '../assets/pic1.png'
import { supabase } from '../supabase';
import { useState } from 'react';
import { useEffect} from 'react';
import Inputtext from '../components/common/input';
import Cta from '../components/common/cta';
import './signup.css'
import CircleCta from '../components/common/circleviewcta';
import { useNavigate } from 'react-router-dom';
import Preloader from '../components/common/preloader';
import Errormsginput from '../components/common/errormsginput';


const Signup = () => {


const [nameError, setNameError] = useState("");
const [emailError, setEmailError] = useState("");
const [passwordError, setPasswordError] = useState("");
const [agreedError, setAgreedError] = useState("");
const [name, setName] = useState("");
const [email, setEmail] = useState("");
const [password, setPassword] = useState("");
const [agreed, setAgreed] = useState(false);


 const [content, setcontent]= useState([]);
      useEffect(() => {
      const getcontent = async()=>{
          const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;;
    
      setcontent(res.data);
      }
      getcontent();
      }, []);



const navigate = useNavigate();


                  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Preloader />


    const handleSignup = (e) => {
           e.preventDefault();
    let hasError = false;

    if (!name) { setNameError("Name is required"); hasError = true; }
        else setNameError("");

    if (!email) { setEmailError("Email is required"); hasError = true; }
          else if (!/\S+@\S+\.\S+/.test(email)) { setEmailError("Invalid email format"); hasError = true; }
    else setEmailError("");

    if (!password) { setPasswordError("Password is required"); hasError = true; }
         else if (password.length < 8) { setPasswordError("At least 8 characters"); hasError = true; }
    else setPasswordError("");

    if (!agreed) { setAgreedError("You must agree to terms"); hasError = true; } else setAgreedError("");

    if (hasError) return;

    navigate('/login');
    };




    return ( 
        <>
        <main className='login-background'>
                <section className='main-sec-login'>
                        <section className='top-sec-signup'>
                            <button className='button-backk' onClick={() => navigate('/login')}>
                            <CircleCta />
                            </button>
                            <img className='logologin' src={pic1} alt='logo'></img>
                             <button className='button-backk'></button>
                        </section>
                        <form className='container-login-card' onSubmit={handleSignup}>
                            <fieldset className='login-card'>
                                    <fieldset className='sub-cont-login'>
                                        <h1 className='loginheader'>{content?.[23]?.header}</h1>


                                        <fieldset className='container-login--inputs-and-cta'>
                                        <fieldset className='container-inputss'>

                                            <Inputtext id='fullname'  label='Full Name' placeholder='Enter your name'
                                             value={name}
                                                onChange={(e) => setName(e.target.value)} />
                                                <Errormsginput message={nameError} />

                                            <Inputtext id='email'  label='Email Address' placeholder='Enter your email address'
                                              value={email}  onChange={(e) => setEmail(e.target.value)} />
                                                <Errormsginput message={emailError} />

                                            <fieldset className='container-forgot-password'>
                                                <Inputtext 
                                                id="password"
                                                label="Password"
                                                type="password"
                                                placeholder="Enter your password"
                                               value={password}
                                                    onChange={(e) => setPassword(e.target.value)} />
                                                <Errormsginput message={passwordError} />

                                            </fieldset>


                                             <p className='password-instructios-text'>Your password must be at least 8 characters long 
                                                and include at least one uppercase, lowercase
                                                 letter, one number, and one special character (!@#$.).</p>

                                            <section className='container-checkbox-signupp'>
                                            <label className="custom-checkbox" onChange={(e) => setAgreed(e.target.checked)}>
                                                            <input type="checkbox" />
                                                            <span className="checkmark"></span>
                                                            I agree on all terms and conditions
                                             </label>

                                             <Errormsginput message={agreedError} />
                                            </section>

                                        </fieldset>

                                                    <Cta title={content?.[23]?.cta} />



                                        </fieldset>




                                    </fieldset>
                            </fieldset>
                        </form>
                </section>
        </main>
        </>
     );
}
 
export default Signup;